export const getTimestamp = () => Date.now();
